// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1122":"3d71cefc","3601":"33847d26","8056":"58c03693","9823":"33847d26"}[chunkId] + ".chunk.css";
};